import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import {
  AdminContainer,
  AdminHeader,
  TabContainer,
  Tab,
  AdminContent,
  MobileSelect,
} from "../styles";
import {
  AdminManager,
  Spinner,
  CouponGenerator,
  BookingDetailsWithSelection,
  BlockDates,
  PriceAdjustment,
  UserDetailsWithList,
  UserHistory,
  UsersByRole,
  AppointmentTabs,
  ProfessorApproval,
} from "../components";
import { adminUserCount } from "../api";

const AdminPanel = () => {
  const [activeTab, setActiveTab] = useState("grantAdmin");
  const [allUsers, setAllUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(true);

  const navigate = useNavigate();

  const tabs = [
    { key: "grantAdmin", label: "Gerenciar Admins" },
    { key: "generateCoupons", label: "Gerar Cupons" },
    { key: "manageBookings", label: "Cancelar Marcações" },
    { key: "blockDates", label: "Bloquear Datas" },
    { key: "adjustPrice", label: "Alterar Preços" },
    { key: "viewUserDetails", label: "Dados de Usuários" },
    { key: "bookingHistory", label: "Histórico de Marcações" },
    { key: "userStats", label: "Estatísticas de Usuários" },
    { key: "userByRole", label: "Usuários por Role" },
    { key: "professorApproval", label: "Aprovação de Usuários" },
  ];

  const activeContent = useMemo(() => {
    switch (activeTab) {
      case "grantAdmin":
        return <AdminManager allUsers={allUsers} />;
      case "generateCoupons":
        return <CouponGenerator allUsers={allUsers} />;
      case "manageBookings":
        return <BookingDetailsWithSelection />;
      case "blockDates":
        return <BlockDates />;
      case "adjustPrice":
        return <PriceAdjustment />;
      case "viewUserDetails":
        return <UserDetailsWithList />;
      case "bookingHistory":
        return <AppointmentTabs />;
      case "userStats":
        return <UserHistory allUsers={allUsers} />;
      case "userByRole":
        return <UsersByRole allUsers={allUsers} />;
      case "professorApproval":
        return <ProfessorApproval />;
      default:
        return null;
    }
  }, [activeTab, allUsers]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {

        const response = await adminUserCount();

        if (!response.ok) {
          throw new Error('Token inválido ou expirado.');
        }
  
        const data = await response.json();
  
        setAllUsers(data);

      } catch (error) {
        console.log('Erro ao buscar os usuários: ', error);
        localStorage.removeItem('token');
        navigate("/login", {replace: true});

      } finally {
        setLoadingUsers(false);
      }
    };

    fetchUsers();
  }, [activeTab, navigate]);

  if (loadingUsers) {
    return <Spinner />;
  }

  return (
    <AdminContainer>
      <AdminHeader>Painel de Administração</AdminHeader>

      {/* Tabs para Desktop */}
      <TabContainer>
        {tabs.map((tab) => (
          <Tab
            key={tab.key}
            active={activeTab === tab.key}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </Tab>
        ))}
      </TabContainer>

      {/* Select Dropdown para Mobile */}
      <MobileSelect
        value={activeTab}
        onChange={(e) => setActiveTab(e.target.value)}
      >
        {tabs.map((tab) => (
          <option key={tab.key} value={tab.key}>
            {tab.label}
          </option>
        ))}
      </MobileSelect>

      {/* Renderiza o conteúdo da aba ativa */}
      <AdminContent>
        {activeContent}
      </AdminContent>
    </AdminContainer>
  );
};

export default AdminPanel;
